import { Menu } from "lucide-react";
import { openMobileNav } from "@/hooks/use-mobile-nav";

/**
 * Bouton burger flottant visible uniquement < md, qui ouvre le drawer
 * latéral de la sidebar. Position fixée en haut-gauche pour rester
 * accessible quand on scrolle.
 */
export function MobileNavTrigger() {
  return (
    <button
      type="button"
      onClick={openMobileNav}
      aria-label="Ouvrir le menu"
      data-testid="mobile-nav-trigger"
      className="md:hidden fixed top-3 left-3 z-30 w-10 h-10 rounded-xl bg-white dark:bg-gray-900 shadow-md border border-gray-200 dark:border-gray-700 flex items-center justify-center text-brand-primary hover:bg-gray-50 dark:hover:bg-gray-800 active:scale-95 transition"
    >
      <Menu className="w-5 h-5" />
    </button>
  );
}
